export enum Period {
  DAY,
  WEEK,
  MONTH,
  YEAR,
}
